export const CAMP_LIST = "CAMP_LIST";
export const CREATE_MEETING = "CREATE_MEETING";
export const POC_LIST_DROPDOWN = "POC_LIST_DROPDOWN";
export const MEETING_BY_ID = "MEETING_BY_ID";
export const CANCEL_MEETING = "CANCEL_MEETING";
export const COMPLETE_MEETING = "COMPLETE_MEETING";
export const VIEW_MOM = "VIEW_MOM";
export const VENDOR_LIST = "VENDOR_LIST";
export const GET_PRECAMP_QUES = "GET_PRECAMP_QUES";
export const POST_PRECAMP_QUES = "POST_PRECAMP_QUES";
export const ADD_POST_CAMP = "ADD_POST_CAMP";
export const VIEW_VENDOR = "VIEW_VENDOR";
export const CAMP_APPROVAL = "CAMP_APPROVAL";
export const INFRA_ID = "INFRA_ID";
export const CARNIVAL_LIST = "CARNIVAL_LIST";
export const CARNIVAL_DETAIL = "CARNIVAL_DETAIL";
export const CARNIVAL_DATA = "CARNIVAL_DATA";
export const NORMAL_BOARDING_LISTING = 'NORMAL_BOARDING_LISTING';
export const NORMAL_ONBAORDING_DATA = 'NORMAL_ONBAORDING_DATA';
export const PROJECT_ONBOARDING_LISTING = 'PROJECT_ONBOARDING_LISTING'
export const HELPDESK_LIST = "HELPDESK_LIST";
export const HELPDESK_DETAIL = "HELPDESK_DETAIL";
export const HELPDESK_DATA = "HELPDESK_DATA";
export const CLIENT_ADDRESS_DETAILS = "CLIENT_ADDRESS_DETAILS";
export const BUSINESS_ADDRESS_DETAILS = "BUSINESS_ADDRESS_DETAILS";

